import { render, staticRenderFns } from "./modal-confirm-delete.vue?vue&type=template&id=b788f2bc"
import script from "./modal-confirm-delete.vue?vue&type=script&lang=js"
export * from "./modal-confirm-delete.vue?vue&type=script&lang=js"
import style0 from "./modal-confirm-delete.vue?vue&type=style&index=0&id=b788f2bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports